import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export enum ImageTypeEnum {
  JPEG = 'image/jpeg',
  PNG = 'image/png'
}

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor() { }

  canvasToBlob(canvas: HTMLCanvasElement, contentType: ImageTypeEnum, quality: number): Observable<Blob> {
    return new Observable((observer) => {
      if (canvas.toBlob) { // native toBlob support
        canvas.toBlob((blob) => {
          observer.next(blob);
          observer.complete();
        }, contentType, quality);
      } else { // fallback support
        const imageData = canvas.toDataURL(contentType, quality);
        const blob = this.base64ToBlob(imageData, contentType);
        observer.next(blob);
        observer.complete();
      }
    });
  }

  base64ToBlob(imageData: string, contentType: ImageTypeEnum): Blob {
    const byteString = atob(imageData.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: contentType });
  }
}
